import { api } from "@/api/client";

export const profileGalleryApi = {
  media: (excludePrivate = 1) => api.get(`/profile-gallery/media?exclude_private=${excludePrivate}`).then((r) => r.data),
  upload: (files) => {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append("files", f));
    return api.post("/profile-gallery/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  renameMedia: (id, filename) => api.patch(`/profile-gallery/media/${id}`, { filename }).then((r) => r.data),
  deleteMedia: (id) => api.delete(`/profile-gallery/media/${id}`).then((r) => r.data),
  albums: () => api.get("/profile-gallery/albums").then((r) => r.data),
  createAlbum: (name, priv) => api.post("/profile-gallery/albums", { name, private: !!priv }).then((r) => r.data),
  updateAlbum: (id, patch) => api.patch(`/profile-gallery/albums/${id}`, patch).then((r) => r.data),
  deleteAlbum: (id) => api.delete(`/profile-gallery/albums/${id}`).then((r) => r.data),
};

// Streamed authed blob URL for a profile-gallery media item.
export const streamProfileMedia = async (id) => {
  const res = await api.get(`/profile-gallery/media/${id}/file`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};
